import { BankReconciliationReportTemplate } from "../../Templates/BankReconciliationReportTemplate";

export const BankReconciliationReport = () => {
  return <BankReconciliationReportTemplate />;
};
